import { gql, type TypedDocumentNode } from '@apollo/client';

import type {
  MarkAllNotificationsReadPayload,
  NotificationPayload,
  NotificationPreferencePayload,
  NotificationType,
} from '../types/notifications.types';

/** Marks one notification read. Returns the updated notification so Apollo normalises it by id. */
export const MARK_NOTIFICATION_READ: TypedDocumentNode<
  { markNotificationRead: NotificationPayload },
  { input: { notificationId: string } }
> = gql`
  mutation MarkNotificationRead($input: MarkNotificationReadInput!) {
    markNotificationRead(input: $input) {
      notification {
        id
        isRead
        readAt
      }
      errors {
        code
        message
      }
    }
  }
`;

/** Marks every unread notification read, reporting how many changed. */
export const MARK_ALL_NOTIFICATIONS_READ: TypedDocumentNode<
  { markAllNotificationsRead: MarkAllNotificationsReadPayload },
  Record<string, never>
> = gql`
  mutation MarkAllNotificationsRead {
    markAllNotificationsRead {
      markedCount
      errors {
        code
        message
      }
    }
  }
`;

/** Sets the delivery preference for one notification type, returning the saved effective state. */
export const UPDATE_NOTIFICATION_PREFERENCE: TypedDocumentNode<
  { updateNotificationPreference: NotificationPreferencePayload },
  { input: { type: NotificationType; inAppEnabled: boolean; emailEnabled: boolean } }
> = gql`
  mutation UpdateNotificationPreference($input: UpdateNotificationPreferenceInput!) {
    updateNotificationPreference(input: $input) {
      preference {
        type
        inAppEnabled
        emailEnabled
        isMandatory
      }
      errors {
        code
        message
      }
    }
  }
`;
